import { render, staticRenderFns } from "./EditPage.vue?vue&type=template&id=0f22e645&"
import script from "./EditPage.vue?vue&type=script&lang=ts&"
export * from "./EditPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f22e645')) {
      api.createRecord('0f22e645', component.options)
    } else {
      api.reload('0f22e645', component.options)
    }
    module.hot.accept("./EditPage.vue?vue&type=template&id=0f22e645&", function () {
      api.rerender('0f22e645', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/account-payables/amortization/EditPage.vue"
export default component.exports